import DropdownValues from "../Student/Reusablecomponents/DropDownValues";
import React, { useEffect, useState } from "react";
import axios from "axios";
import axiosInstance from "../ReusableComponents/Axios";
import { useSelector, useDispatch } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import { IoCloseCircleOutline } from "react-icons/io5";

export function Institute(props) {
  const [InstituteOptions, SetInstituteOptions] = useState([]);

  const GetInstitutes = async () => {
    await axios
      .get(process.env.REACT_APP_API_BASE_URL + `/NCLAdmin/Institutes`, {
        headers: { XApiKey: process.env.REACT_APP_XApiKey },
      })
      .then((res) => {
        const Institutes = res.data.map((item) => ({
          display: item.instituteName,
          value: item.instituteId,
          Code: item.instituteCode,
        }));
        SetInstituteOptions(Institutes);
        const Selected = Institutes.find(
          (item) => item.value === props.SOption,
        );
        if (props.StoreValue) {
          props.StoreValue(
            Selected
              ? props.SOption
              : { Value: Institutes[0]?.value, Code: Institutes[0]?.Code },
          );
        }
        // console.log(Selected ? props.SOption : Institutes[0]?.value);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetInstitutes();
  }, []);
  const PostValue = (e) => {
    const selectedOption = InstituteOptions.find(
      (opt) => opt.value === Number(e),
    );
    if (selectedOption) {
      props.onChange({
        Value: selectedOption.value,
        Code: selectedOption.Code,
      });
    }
  };
  return (
    <>
      <DropdownValues
        className={props.className}
        options={InstituteOptions}
        selectoption={props.SOption}
        onChange={(e) => PostValue(e.target.value)}
        labelname={props.labelname}
        disabled={props.disable}
        Displayname={props.Displayname}
      />
    </>
  );
}

export function DSRCodes(props) {
  const [DSROptions, SetDSROptions] = useState();

  const GetDSRDetails = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/CommonAPI/GetInstituteHierarchyValuesByParentId?InstituteId=${props.PId}&ParentId=${props.id}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        const RSDetails = res.data.map((item) => ({
          display: item.values,
          value: item.id,
        }));
        // const  = Array.from(
        //   res.data
        //     .reduce(
        //       (map, item) =>
        //         map.set(item.id, { display: item.values, value: item.id ,Code:item.lovName}),
        //       new Map()
        //     )
        //     .values()
        // );
        SetDSROptions(RSDetails);
        // SetDSROptions([...RSDetails, { display: "All", value: 0 }]);
        // props.StoreOptions([...RSDetails, { display: "All", value: 0 }]);
        props.StoreValue(props.SOption || RSDetails[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.PId && props.id) {
      GetDSRDetails();
    } else {
      SetDSROptions();
    }
  }, [props.PId, props.id]);
  const PostValue = (e) => {
    const selectedOption = DSROptions.find((opt) => opt.value === Number(e));
    // console.log("selectedOption",selectedOption)
    if (selectedOption) {
      props.onChange(selectedOption);
    }
  };
  return (
    <>
      <DropdownValues
        className={props.className}
        options={DSROptions}
        selectoption={props.SOption}
        onChange={(e) => PostValue(e.target.value)}
        labelname={props.labelname}
        disabled={props.disable}
        Displayname={props.Displayname}
      />
    </>
  );
}

export function Society(props) {
  const [societyOptions, SetsocietyOptions] = useState();

  const GetsocietyDetails = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetSocietyByInstitute?InstituteId=${props.PId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        const RSDetails = res.data.map((item) => ({
          display: item.societyCode,
          value: item.societyId,
        }));
        SetsocietyOptions(RSDetails);
        const Selected = RSDetails.find(
          (item) => item.value === (props.SOption?.value || props.SOption),
        );
        if (props.StoreValue) {
          props.StoreValue(Selected ? props.SOption : RSDetails[0]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetsocietyDetails();
  }, [props.PId]);

  const PostValue = (e) => {
    const selectedOption = societyOptions.find(
      (opt) => opt.value === Number(e),
    );
    if (selectedOption) {
      props.onChange(selectedOption);
    }
  };
  return (
    <>
      <DropdownValues
        className={props.className}
        options={societyOptions}
        selectoption={props.SOption?.value || props.SOption}
        onChange={(e) => PostValue(e.target.value)}
        labelname={props.labelname}
        disabled={props.disable}
        Displayname={props.Displayname}
      />
    </>
  );
}

export function DDGradeChapter(props) {
  const [Options, SetOptions] = useState();
  const GetGradeChapter = async () => {
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=${props.LovCategoryId}&ParentLovId=0&LanguageId=${props.LID}`,
      );
      const OrderOptions = res.data.map((item) => ({
        display: item.lovDescription,
        value: item.lovId,
      }));
      SetOptions(OrderOptions);
      let Selected = OrderOptions.find(
        (item) => item.value === parseInt(props.SOption),
      );
      props.StoreValue(Selected ? props.SOption : "");
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    GetGradeChapter();
  }, [props.PId]);

  return (
    <DropdownValues
      Displayname={props.Displayname}
      disabled={props.disable}
      className={props.className}
      options={Options}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={props.labelName}
    />
  );
}
// Below is for number of assessments are avaliable
export function GetAssessmentsNames(props) {
  const [Options, SetOptions] = useState([]);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const GetANames = async () => {
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=73&ParentLovId=0&LanguageId=0`,
      );
      let FormatedOptions;
      if (USYear?.display === "2024-25" || USYear?.display === "2025-26" ) {
        FormatedOptions = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));

      } 
      else if(props.GetAll) {
        FormatedOptions = res.data.filter(item => !item?.lovName.startsWith("SA")).map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
      }
      else if (items?.userTypeId == 1) {
        FormatedOptions = res.data.filter((TT) => TT.lovName.startsWith("SO")).map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
      }
      SetOptions(FormatedOptions);
      props.StoreValue(FormatedOptions[0]);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    GetANames();
  }, [USYear]);
  const HandleChange = (e) => {
    const selectedOption = Options.find((opt) => opt.value === Number(e));
    if (selectedOption) {
      props.StoreValue(selectedOption);
    }
    // props.onChange(e.target.value)
  };
  return (
    <DropdownValues
      className={props.className}
      options={Options}
      selectoption={props.SOption}
      onChange={(e) => HandleChange(e.target.value)}
      labelname={props.labelname}
      disabled={props.disable}
      Displayname={props.Displayname}
    />
  );
}
// Above is for number of assessments are avaliable
// Below is Institutes based on Assessment Number
export function GetANamesInStitutes(props) {
  const [Options, SetOptions] = useState([]);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const GetANInstitutes = async () => {
    if (props.ClearValue) {
      props.ClearValue("0");
    }
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetInstituteByAssessmentType?AssessmentTypeNo=${props.ATypeNO}&Year=${USYear?.value}`,
      );
      const FormatedOptions = res.data.map((item) => ({
        display: item.instituteName,
        value: item.instituteId,
        Code: item.instituteCode,
      }));
      SetOptions(FormatedOptions);
      props.StoreValue(FormatedOptions[0]);
      // console.log(FormatedOptions[0])
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (props.ATypeNO) {
      GetANInstitutes();
    }
  }, [props.ATypeNO, USYear]);
  const HandelChangeValue = (e) => {
    if (props.ClearValue) {
      props.ClearValue("0");
    }
    const selectedOption = Options.find((opt) => opt.value === Number(e));
    if (selectedOption) {
      props.StoreValue(selectedOption);
    }
  };
  return (
    <DropdownValues
      className={props.className}
      options={Options}
      selectoption={props.SOption}
      onChange={(e) => HandelChangeValue(e.target.value)}
      labelname={props.labelname}
      disabled={props.disable}
      Displayname={props.Displayname}
    />
  );
}
// Above is Institutes based on Assessment Number

// Below is for Getting Assessment Dates and Grade
export function GetAssDateGrades(props) {
  const [Options, SetOptions] = useState([]);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const GetDateGrades = async () => {
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetGradeBasedOnInstituteAndSociety?AssessmentTypeNo=${props.ATypeNO
        }&InstituteId=${props.InstID}&Year=${USYear?.value}&SocietyId=${props.Scoiety || 0
        }`,
      );
      const FormatedOptions = res.data.map((item) => ({
        display: item.testStartDate,
        value: item.contestCreationId,
        ...item,
      }));
      SetOptions(FormatedOptions);
      props.StoreValue(FormatedOptions[0]);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (props.ATypeNO && props.InstID) {
      GetDateGrades();
    }
  }, [props.ATypeNO, props.InstID, props.Scoiety]);
  const HandelChangeValue = (e) => {
    const selectedOption = Options.find((opt) => opt.value === Number(e));
    if (selectedOption) {
      props.StoreValue(selectedOption);
    }
  };
  return (
    <DropdownValues
      className={props.className}
      options={Options}
      selectoption={props.SOption}
      onChange={(e) => HandelChangeValue(e.target.value)}
      labelname={props.labelname}
      disabled={props.disable}
      Displayname={props.Displayname}
    />
  );
}
// Above is for Getting Assessment Dates and Grade

//Below is for getting the Station/Contonment Names
export function GetStationorCantonmentNames(props) {
  const [Options, SetOptions] = useState([]);

  const GetStationNames = async () => {
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=77&ParentLovId=0&LanguageId=0`,
      );
      const FormatedOptions = res.data.map((item) => ({
        display: item.lovDescription,
        value: item.lovId,
      }));
      SetOptions(FormatedOptions);
      props.StoreValue(FormatedOptions[0]?.value);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    GetStationNames();
  }, []);

  return (
    <DropdownValues
      className={props.className}
      options={Options}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={props.labelname}
      disabled={props.disable}
      Displayname={props.Displayname}
    />
  );
}

export function GetQBAdminUsers(props) {
  const [Options, SetOptions] = useState([]);
  const GetUsers = async () => {
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetQBAdminUsersbySubject?SubjectId=${props.SUBId}`);
      // console.log("Users", res.data)
      const FormatedOptions = res.data.map((item) => ({ Name: item.loginId, value: item.userId, }));
      props.Storevalue([FormatedOptions[0]]);
      SetOptions(FormatedOptions);
      // console.log("FormatedOptions", FormatedOptions)
      // props.StoreValue(FormatedOptions[0]?.value);
    }
    catch (err) {
      console.log(err)
    }
  };
  useEffect(() => {
    GetUsers();
    // props.Storevalue([]);
  }, [props.SUBId]);
  return (
    <div className="MULQBUsers w-100">
      Select QB User
      <Multiselect
        isObject={true}
        className="w-100"
        // onKeyPressFn={(e)=>harsha(e)}
        onRemove={(e, r) => props.onChange(e, r)}
        // style={{ searchBox: { minHeight: "10vh" } }}
        // onSearch={function noRefCheck() {}}
        displayValue="Name"
        // groupBy="Group"
        // ref={ref}
        customCloseIcon={<IoCloseCircleOutline fontSize="14px" />}
        // singleSelect={SelectSubject?.length > 1}
        placeholder="Select QB Users"
        selectedValues={props.selected.length > 0 ? props.selected : ""}
        // disable ="true"
        // selectedValueDecorator = {(e)=> e.split(' ')[1]}
        // optionValueDecorator = {(e)=> e.split(' ')[1]} 
        avoidHighlightFirstOption="false"
        // disablePreSelectedValues="true"
        onSelect={(e, r) => props.onChange(e, r)}
        options={Options}
        showCheckbox
        selectionLimit={10}
      />
    </div>
  )
}